import React from 'react';
import styled from 'styled-components';
import { CampaignStatus } from '../../models';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import { campaignStatusBackground, campaignStatusColor, getCampaignStatusTranslationKey } from './campaignsUtils';

const Badge = styled.span<{ $status: CampaignStatus }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.2rem 0.55rem;
    border-radius: 999px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: ${({ $status }) => campaignStatusColor($status)};
    background: ${({ $status }) => campaignStatusBackground($status)};
    border: 1px solid ${({ $status }) => campaignStatusColor($status)};
`;

export const CampaignStatusBadge: React.FC<{ status: CampaignStatus }> = ({ status }) => {
    const t = useTranslations();

    return (
        <Badge $status={status}>
            {t(getCampaignStatusTranslationKey(status) ?? TK.unknown)}
        </Badge>
    );
}
